/* eslint-disable max-len */
import { Box } from '@mui/material';
import React, { useContext, useMemo, useState } from 'react';
import EnhancedTable from 'Shared/EnhancedTable';
import { withoutTime } from 'Utils/ulilities';
import ConfirmRemoveDialog from 'Shared/ConfirmDialog/ConfirmRemoveDialog';
import { saveDeletedOrders, saveOrders } from '../Actions';
import OrdersContext from '../Context';
import Filters from '../Filters';
import { DEFAULT_VALUES } from '../NewOrder/constants';
import { columns } from './constants';
import NewOrder from '../NewOrder';

const SalesOrders = () => {
  const {
    dispatch,
    state: { orders, deletedOrders },
  } = useContext(OrdersContext);
  const [values, setValues] = useState(DEFAULT_VALUES);
  const [openNewOrder, setOpenNewOrder] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openConfirm, setOpenConfirm] = useState({ open: false });
  const handleInputChange = (prop) => (event, value) => {
    setValues({ ...values, [prop]: event instanceof Date ? event : value || event?.target.value });
  };
  const deleteOrder = (event) => {
    event.stopPropagation();
    dispatch(saveOrders(orders.filter((o) => o.id !== openConfirm.id)));
    dispatch(saveDeletedOrders([...deletedOrders, orders.find((o) => o.id === openConfirm.id)]));
    setOpenConfirm({ open: false });
  };
  const confirmDeleteOrder = (id) => (event) => {
    event.stopPropagation();
    setOpenConfirm({ open: true, id });
  };
  const handleRefresh = () => {
    setValues({ ...DEFAULT_VALUES });
  };
  const handleCloseNewOrderModal = () => {
    setSelectedOrder(null);
    setOpenNewOrder(false);
  };

  const handleOpenNewOrderModal = () => {
    setOpenNewOrder(true);
  };
  const handleEditOrder = (id) => () => {
    setSelectedOrder(orders.find((o) => o.id === id));
    handleOpenNewOrderModal();
  };
  const salesOrders = useMemo(
    () => (orders || [])
      .filter(
        (o) => (!values.client || values.client.code === o.client?.code)
            && (!values.expedition || values.expedition.code === o.expedition?.code)
            && (!values.paymentMode || values.paymentMode.code === o.paymentMode?.code)
            && (!values.city || values.city === o.city)
            && (!values.product
              || o.articles.map((a) => a.reference).includes(values.product?.reference))
            && (!values.startDate || withoutTime(values.startDate) <= withoutTime(o.date))
            && (!values.endDate || withoutTime(values.endDate) >= withoutTime(o.date)),
      )
      .map((o) => ({
        amount: o.articles
          ?.reduce((prev, curr) => prev + parseInt(curr.quantity, 10) * curr.p, 0)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, '$& '),
        client: o.client?.name,
        date: o.date,
        expedition: o.expedition?.name,
        paymentMode: o.paymentMode?.name,
        personalInfo: o.personalInfo,
        id: o.id,
        reference: o.id,
        type: o.type?.name,
        click: handleEditOrder(o.id),
        deleteOrder: confirmDeleteOrder(o.id),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date)),
    [orders, values],
  );
  return (
    <>
      {openNewOrder && <NewOrder handleClose={handleCloseNewOrderModal} order={selectedOrder} />}
      {openConfirm.open && (
      <ConfirmRemoveDialog
        title="Suppresion"
        content="Êtes-vous sûr de vouloir supprimer cette commande ?"
        handleClose={() => setOpenConfirm({ open: false })}
        handleClick={deleteOrder}
      />
      )}
      <Box style={{
        display: 'flex',
        padding: 10,
        alignItems: 'center',
        background: '#E9EBED 0% 0% no-repeat padding-box',
        bordeRradius: '0px 0px 12px 12px',
        opacity: 1,
        marginBottom: 16,
      }}
      >
        <Filters
          values={values}
          handleInputChange={handleInputChange}
          handleRefresh={handleRefresh}
        />
      </Box>
      <EnhancedTable
        staticData
        rows={salesOrders}
        headCells={columns}
        count={salesOrders.length}
        rowsPerPageOptions={[10, 15, 20]}
      />
    </>
  );
};

export default SalesOrders;
